<template>
	<transition name="modal">
		<div class="modal-mask animated fadeIn">
			<div class="modal-wrapper">
				<div :class="'modal-container ' + modalSizeClasses">
					<div class="containerWrap small-12 borderRadius7">
						<div class="modal-header">
							<slot name="header"></slot>
						</div>
						<div class="modal-body">
							<slot name="body"></slot>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'Modal',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			//

		],

		/*
		**  Set the props
		*/

		props: {

			modalSizeClasses: {
                type: String,
                default: null
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			//

        }),
        

		/*
		**  Watch em'
		*/

		watch: {

			//

        },
        
        /*
		**  Do this before destroying component
		*/

		beforeDestroy() {

			// Remove the body class
			this.removeBodyClass();

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			removeBodyClass: function(){

                $('body').removeClass('modalFixed');
                
			},

			closeModal: function(){

                $('.modal-mask').hide();
                
			},

			handler: function(){

				// Remove the body class
				this.removeBodyClass();

				// Close the modal
				this.closeModal();

				// Emit the close event to reset the showModal prop
				this.$emit('closeModal');

			}

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>